import React from 'react';
import Button from '@mui/material/Button';
import CircularLoading from './CircularLoading';
import { Typography } from '@mui/material';

export const BlueButton = ({ onClick, text, width, disabled, loading, ...btnProps }) => {
  return (
    <Button
      {...btnProps}
      onClick={onClick}
      variant="contained"
      color="primary"
      disabled={disabled}
      style={{
        textTransform: 'none',
        height: 40,
        width: btnProps.fullWidth ? undefined : width ?? 300,
      }}
    >
      {loading ? <CircularLoading size={20} /> : <Typography>{text}</Typography>}
    </Button>
  );
};
